import { createContext } from 'react'

export const FerramentaToolContext = createContext<string>('')
